import NiceSelect from "nice-select2";
let niceSelectOptions = document.querySelectorAll('.nice-select-custom');
niceSelectOptions.forEach(niceSelectOption => {
    new NiceSelect(niceSelectOption, { searchable: false});
});
let newsSortBy=document.querySelector('#newsSortby');
let formNews=document.querySelector('#frmNews');
newsSortBy.addEventListener("change", function(event){
    formNews.submit();
});